import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Blue200 } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { trackEvent } from '@zep/logger/tracking';
import { Breakpoints } from '@/hooks';
import { FolderFillIcon } from '@/icons';
import { useIsLoggerUserInfoSet } from '@/lib/auth';

/**
 * 우측 폴더 프로모션 카드. 남의 폴더를 볼 때 사이드를 채운다.
 *
 * 닫을 수 없다 — 닫고 나면 폴더 설명을 다시 볼 방법이 없었고, 비운 자리만 남았다.
 */
export const FolderPromoCard = ({
  folderId
}: {
  folderId: string;
}) => {
  const {
    t
  } = useTranslation(['common']);

  // 마운트 직후엔 유저 정보가 로거에 실리기 전이라 IS_LOGIN·userId 가 빠진다. 실린 뒤에 한 번 보낸다.
  const isLoggerUserInfoSet = useIsLoggerUserInfoSet();
  // 카드가 든 aside 는 태블릿 미만에서 CSS 로만 숨고 마운트는 그대로다. 보일 때만 노출로 센다.
  const isVisible = useMediaQuery({
    minWidth: Breakpoints.tabletSm
  });
  useEffect(() => {
    if (!isLoggerUserInfoSet || !isVisible) return;
    trackEvent('quiz_folder_promo_card_view', {
      folder_id: folderId
    });
  }, [isLoggerUserInfoSet, isVisible, folderId]);
  return <div className={'flex w-full flex-col overflow-hidden rounded-md border border-opacity-assistive bg-neutral'} data-sentry-component="FolderPromoCard" data-sentry-source-file="FolderPromoCard.tsx">
      <div className={'flex min-h-[100px] flex-col gap-xs px-md py-sm'}>
        <span className={'flex min-h-[30px] min-w-px items-center gap-3xs text-body-sm-bold text-neutral'}>
          <FolderFillIcon size={'xs'} fill={Blue200} data-sentry-element="FolderFillIcon" data-sentry-source-file="FolderPromoCard.tsx" />
          {t('common:folder.label.folders')}
        </span>
        <p className={'text-body-sm-medium text-neutral'}>
          {t('common:folder.detail.promo.description')}
        </p>
      </div>
      <FolderPromoIllustration data-sentry-element="FolderPromoIllustration" data-sentry-source-file="FolderPromoCard.tsx" />
    </div>;
};

/**
 * 흩어진 퀴즈가 폴더로 모이는 그림. 레이어로 쌓으면 테두리·그림자가 시안과 어긋나 시안을 통째로 내보낸 이미지를 쓴다.
 *
 * 1배로 내보내면 흐려서 2배(496×260)로 내보내 절반 크기로 그린다.
 */
const FolderPromoIllustration = () => <img src={'/assets/folder/promo-illustration@2x.webp'} alt={''} aria-hidden className={'block h-[130px] w-full object-cover'} data-sentry-component="FolderPromoIllustration" data-sentry-source-file="FolderPromoCard.tsx" />;